// import { renderRoot } from "../constants/elements";

// export const render = (html: any, className?: any): void => {
//   const add_this = document.createElement("div");
//   add_this.className = "retail-av-append-response";
//   add_this.id = className;
//   // eslint-disable-next-line github/no-inner-html
//   add_this.innerHTML = html;
//   renderRoot.appendChild(add_this);
// };

import { parentContainer } from "../constants/elements";

export const render = (html: Node, className?: string): void => {
  while (parentContainer.firstChild) {
    parentContainer.removeChild(parentContainer.firstChild);
  }
  parentContainer.append(html);
  parentContainer.className = className || "";
};
